/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Facebook`)
};

const es_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con Facebook`)
};

const de_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Facebook fortfahren`)
};

const nl_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorgaan met Facebook`)
};

const fr_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer avec Facebook`)
};

const it_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua con Facebook`)
};

const pt_br2_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com Facebook`)
};

const pt_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com Facebook`)
};

const ja_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebookで続ける`)
};

const zh_auth_continue_facebook = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用Facebook继续`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_continue_facebook = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_continue_facebook(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_continue_facebook", locale)
	if (locale === "en") return en_auth_continue_facebook(inputs)
	if (locale === "es") return es_auth_continue_facebook(inputs)
	if (locale === "de") return de_auth_continue_facebook(inputs)
	if (locale === "nl") return nl_auth_continue_facebook(inputs)
	if (locale === "fr") return fr_auth_continue_facebook(inputs)
	if (locale === "it") return it_auth_continue_facebook(inputs)
	if (locale === "pt-BR") return pt_br2_auth_continue_facebook(inputs)
	if (locale === "pt") return pt_auth_continue_facebook(inputs)
	if (locale === "ja") return ja_auth_continue_facebook(inputs)
	return zh_auth_continue_facebook(inputs)
};